import { get, post, destroy, put} from './../Client/BaseClient';

export const ElectronicHousingUnitApi = {
    getElectronicHousingUnits: () =>
        get('ElectronicHousingUnits'),
    getElectronicHousingUnit: (id) =>
        get(`ElectronicHousingUnits/${id}`),
    getElectronicHousingUnitParts: (id) =>
        get(`ElectronicHousingUnits/${id}/Parts`),
    getElectronicHousingUnitVehicles: (id) =>
        get(`ElectronicHousingUnits/${id}/Vehicles`),
    createElectronicHousingUnit: (param) =>
        post('ElectronicHousingUnits', param),
    updateElectronicHousingUnit: (id, param) =>
        put(`ElectronicHousingUnits/${id}`, param),
    deleteElectronicHousingUnit: (id) =>
        destroy(`ElectronicHousingUnits/${id}`),
    remarkElectronicHousingUnit: (id, param) =>
        post(`ElectronicHousingUnits/${id}/Remarks`, param),
    editRemark: (id, text) =>
        post(`ElectronicHousingUnits/Remarks/Edit`, {id: id, remark: text}),
    deleteRemark: (id) =>
        destroy(`ElectronicHousingUnits/Remarks/${id}/Delete`),
    addPart: (id, partId) =>
        put(`ElectronicHousingUnits/${id}/Parts/${partId}/Add`),
    removePart: (id, partId) =>
        put(`ElectronicHousingUnits/${id}/Parts/${partId}/Remove`),
    addVehicle: (id, vehicleId) =>
        put(`ElectronicHousingUnits/${id}/Vehicles/${vehicleId}/Add`),
    removeVehicle: (id, vehicleId) =>
        put(`ElectronicHousingUnits/${id}/Vehicles/${vehicleId}/Remove`),
};